export const environment = {
  production: true,
  gameCardioPreview: false,
  gameCardioEnabled: true,
  gameCardioProductionTest: false,
  urlApiPadrao: 'https://api.dashboard.icons4u.com.br/',
  urlApiProcessamento: 'http://localhost:3014/',
  urlMedia: 'http://localhost:3020/media-volume/',
  X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
  debugMode: 'warn',
};
